import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FunnelStage, ReportFilters } from '../../../core/models/report.model';
import { PermissionService } from '../../../core/services/permission.service';
import { ReportsService } from '../../../core/services/reports.service';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { CardActionsComponent } from '../../../shared/components/card/card-actions.component';
import { CardContentComponent } from '../../../shared/components/card/card-content.component';
import { CardHeaderComponent } from '../../../shared/components/card/card-header.component';
import { CardTitleComponent } from '../../../shared/components/card/card-title.component';
import { CardComponent } from '../../../shared/components/card/card.component';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { ReportFilterBarComponent } from '../../../shared/components/report-filter-bar/report-filter-bar.component';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

/**
 * "Doors -> contacts -> leads -> appointments -> won" (design doc §8). Print/view only,
 * no CSV/XLSX -- §8's own table lists "Print" as this report's only export column since
 * it's one computed summary, not a row-per-record table CSV would suit.
 */
@Component({
  selector: 'app-funnel',
  standalone: true,
  imports: [
    ButtonComponent,
    CardComponent,
    CardHeaderComponent,
    CardTitleComponent,
    CardContentComponent,
    CardActionsComponent,
    IconComponent,
    ReportFilterBarComponent,
    SpinnerComponent,
    TranslatePipe,
  ],
  templateUrl: './funnel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./funnel.component.css', '../../../../css/report-print.css'],
})
export class FunnelComponent {
  private reportsService = inject(ReportsService);
  private permissionService = inject(PermissionService);

  includeAllUsers = this.permissionService.has('interaction.read-others');

  stages = signal<FunnelStage[]>([]);
  loading = signal(false);

  async onFiltersChange(filters: ReportFilters): Promise<void> {
    this.loading.set(true);
    try {
      this.stages.set(await this.reportsService.getFunnel(filters, this.includeAllUsers));
    } finally {
      this.loading.set(false);
    }
  }

  print(): void {
    window.print();
  }
}
